import { useContext } from "react";
import DashboardContext from "src/context/dashboard-context";
import { formatNumber } from "src/utils/helper/functions";

type DashboardAccountProps = {
  view: string;
  netWorth: number;
  assetsTotal: number;
  liabilitiesTotal: number;
  onDetailsClicked?: () => void;
  showDetails: boolean;
};

const DashboardAccount: React.FC<DashboardAccountProps> = ({
  view,
  netWorth,
  assetsTotal,
  liabilitiesTotal,
  onDetailsClicked,
  showDetails,
}: DashboardAccountProps) => {
  const { selectedAccount } = useContext(DashboardContext);

  return (
    <div className=" h-fit md:h-[258px] justify-start items-start gap-5 inline-flex">
      <div className="h-full grow shrink basis-0 p-3 md:p-4 bg-white rounded-xl add-shadow flex-col justify-start items-start gap-5 inline-flex">
        <div className=" items-center justify-between w-full gap-3 inline-flex">
          <div className="opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold">
            {selectedAccount?.nameEn}
          </div>
          <div
            onClick={onDetailsClicked}
            className="max-w-[100px] grow px-2.5 py-1 bg-[#f5f6fa] rounded-[50px] justify-center items-center gap-2.5 flex cursor-pointer"
          >
            <div className="grow items-center justify-center text-center text-[#002f6c] text-xs font-medium whitespace-nowrap w-fit">
              {!showDetails ? "See details" : "Hide details"}
            </div>
          </div>
        </div>
        <div className=" self-stretch justify-start items-start gap-3 h-fit flex flex-col md:flex-row">
          <div className="w-full grow flex-col justify-start items-start gap-5 inline-flex">
            <div className=" self-stretch  flex-col justify-start items-start gap-3 flex">
              <div className=" self-stretch justify-start items-start gap-1 inline-flex">
                <div className=" flex-col justify-start items-start gap-1 inline-flex">
                  <div className="NetWorth opacity-70 text-[#535353] text-sm font-semibold">
                    {view === "portfolio" ? "Net Asset" : "Net worth"}{" "}
                    {selectedAccount?.reportingCurrency &&
                      `(${selectedAccount?.reportingCurrency})`}
                  </div>
                </div>
              </div>
              <div className=" self-stretch">
                <span className="text-[#002f6c] text-2xl md:text-[30px] font-bold">
                  {formatNumber(
                    netWorth,
                    selectedAccount?.reportingCurrencyDcp
                  )}{" "}
                </span>
              </div>
            </div>
            <div className=" self-stretch py-3 justify-start items-center gap-5 inline-flex">
              <div className=" grow shrink basis-0 self-stretch flex-col justify-center items-start gap-2.5 inline-flex">
                <div className=" self-stretch opacity-70 text-[#2a2a2a] text-xs md:text-sm font-medium">
                  Total Assets
                </div>
                <div className="flex items-center gap-1">
                  <img
                    width={7}
                    height={7}
                    src="/images/green-arrow.svg"
                    alt="assets"
                  />
                  <div className=" text-[#40bd6e] text-sm md:text-md font-semibold">
                    {formatNumber(
                      assetsTotal,
                      selectedAccount?.reportingCurrencyDcp
                    )}
                  </div>
                </div>
              </div>
              <div className=" w-px h-[25px] bg-zinc-400 rounded-[11px]" />
              <div className=" grow shrink basis-0 self-stretch flex-col justify-center items-start gap-2.5 inline-flex">
                <div className="TotalAssets self-stretch opacity-70 text-[#2a2a2a] text-xs md:text-sm font-medium">
                  Total Liabilities
                </div>
                <div className="flex items-center gap-1">
                  <img
                    width={7}
                    height={7}
                    src="/images/red-arrow.svg"
                    alt="assets"
                  />
                  <div className=" text-[#F5606F] text-sm md:text-md font-semibold">
                    {formatNumber(
                      Math.abs(liabilitiesTotal),
                      selectedAccount?.reportingCurrencyDcp
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAccount;
